export const maintenanceCatalog = {
  ro: {
    eyebrow: 'Management flotă', title: 'Mentenanță camioane',
    subtitle: 'Urmărește reviziile după kilometraj CAN și dată, într-un singur loc.',
    actions: {
      refresh: 'Actualizează acum', refreshing: 'Se actualizează…', newPlan: 'Plan nou', types: 'Tipuri de lucrări',
      cargoTrack: 'Configurare CargoTrack', filters: 'Filtre', clearFilters: 'Resetează', edit: 'Editează planul',
      schedule: 'Programează service', openService: 'Deschide intervenția', history: 'Istoric', save: 'Salvează',
      saving: 'Se salvează…', close: 'Închide', acceptReading: 'Acceptă citirea', retry: 'Reîncearcă',
      previous: 'Înapoi', next: 'Înainte', addType: 'Tip nou', editType: 'Editează tipul', bind: 'Salvează asocierea',
    },
    summary: {
      total: 'Planuri active', urgent: 'Urgente în această pagină', stale: 'CAN neactualizat în pagină',
      daily: 'Actualizare automată', dailyValue: 'Zilnic, la 06:00', dailyHint: 'Ora firmei',
    },
    filters: {
      truck: 'Camion', allTrucks: 'Toate camioanele', importance: 'Importanță', allImportance: 'Toate nivelurile',
      status: 'Status', allStatuses: 'Toate statusurile', scheduled: 'Cu service programat', stale: 'Kilometraj neactualizat',
      withinDays: 'Scadent în maximum (zile)', withinKm: 'Scadent în maximum (km)',
    },
    list: {
      title: 'Reviziile flotei', count: '{{count}} planuri', emptyTitle: 'Nu există planuri pentru filtrele selectate',
      emptyText: 'Resetează filtrele sau creează primul plan de mentenanță.', truck: 'Camion', work: 'Lucrare',
      due: 'Scadență', odometer: 'Kilometraj CAN', importance: 'Importanță', action: 'Acțiuni',
      estimated: 'Estimare: {{date}}', noEstimate: 'Estimare indisponibilă', cycle: 'Ciclul {{number}}',
      page: 'Pagina {{current}} din {{total}}', verificationIncomplete: 'Verificare incompletă din cauza datelor CAN',
    },
    statuses: { OK: 'OK', DUE_SOON: 'Se apropie', DUE: 'Scadentă', OVERDUE: 'Depășită', UNKNOWN: 'Date insuficiente' },
    remaining: {
      km: '{{value}} km rămași', kmOverdue: '{{value}} km depășiți', days: '{{value}} zile rămase',
      daysOverdue: '{{value}} zile depășite', today: 'Scadentă astăzi', noCriteria: 'Scadență indisponibilă',
      dueKm: 'la {{value}} km', dueDate: 'la {{value}}',
    },
    odometer: {
      source: 'Sursă: CAN', value: '{{value}} km', recorded: 'Citire {{date}}', checked: 'Verificat {{date}}',
      noValue: 'Fără kilometraj CAN', valid: 'Actualizat', stale: 'Neactualizat de peste 24 h', unavailable: 'CargoTrack neasociat',
      awaiting_sync: 'În așteptarea sincronizării', missing_can: 'CAN lipsește', invalid_can: 'Valoare CAN invalidă',
      invalid_timestamp: 'Momentul citirii este invalid', needs_review: 'Citirea trebuie verificată',
      provider_unavailable: 'CargoTrack indisponibil', acceptQuestion: 'Confirmă numai după compararea cu bordul camionului.',
    },
    sync: {
      queued: 'Actualizarea este în așteptare.', running: 'Datele CargoTrack se actualizează.',
      completed: 'Datele de mentenanță au fost actualizate.', partial: 'Actualizarea s-a încheiat cu unele erori.',
      failed: 'Actualizarea nu a putut fi finalizată.', progress: '{{processed}} procesate · {{errors}} erori',
      throttled: 'Actualizarea manuală este limitată. Reîncearcă peste {{seconds}} secunde.',
      unavailable: 'Limitarea actualizărilor este temporar indisponibilă. Datele existente au fost păstrate.',
    },
    plan: {
      newTitle: 'Plan nou de mentenanță', editTitle: 'Editare plan de mentenanță', truck: 'Camion', type: 'Tipul lucrării',
      title: 'Denumirea planului', importance: 'Importanță (0–5)', recurring: 'Lucrare recurentă', enabled: 'Plan activ',
      intervalKm: 'Interval kilometri', calendarUnit: 'Interval calendaristic', noCalendar: 'Fără interval calendaristic',
      days: 'Zile', months: 'Luni', calendarValue: 'Valoare interval', basis: 'Punct de pornire',
      lastService: 'Ultima intervenție', directDue: 'Scadență directă', lastDate: 'Data ultimei intervenții',
      sourceIntervention: 'Intervenție Service finalizată (opțional)', sourceInterventionNone: 'Introdu manual ultima intervenție',
      lastKm: 'Kilometrajul ultimei intervenții', dueDate: 'Următoarea dată scadentă', dueKm: 'Următorul kilometraj scadent',
      notifyKm: 'Avertizări kilometri', notifyKmHint: 'Valori separate prin virgulă, de exemplu 2000, 500',
      notifyDays: 'Avertizări zile', notifyDaysHint: 'Valori separate prin virgulă, de exemplu 30, 7',
      responsible: 'Responsabil', recipients: 'Destinatari notificări', noResponsible: 'Fără responsabil',
      recipientsUnavailable: 'Destinatarii pot fi configurați de administrator din lista utilizatorilor firmei.',
      extraAlerts: 'Avertizări suplimentare', costAlert: 'Avertizare pentru cost peste prag', costThreshold: 'Prag cost',
      missingDocument: 'Intervenție finalizată fără document',
      usageAfterDue: 'Camion utilizat după depășirea unei revizii de nivel 5',
      dateOnlyHint: 'Un plan calendaristic poate funcționa și fără CAN valid.',
    },
    types: {
      title: 'Tipuri de mentenanță', subtitle: 'Valorile implicite sunt copiate în plan și pot fi ajustate pe camion.',
      name: 'Denumire', category: 'Categorie Service', enabled: 'Tip activ', empty: 'Nu există tipuri definite.',
      preventive_maintenance: 'Întreținere preventivă', repair: 'Reparație', periodic_revision: 'Revizie periodică', accident: 'Accident',
    },
    cargo: {
      title: 'Configurare CargoTrack', subtitle: 'Asocierea este manuală și folosește exclusiv kilometrajul CAN.',
      truck: 'Camion', object: 'Obiect CargoTrack', noObject: 'Fără asociere', suggested: 'Recomandat după numărul de înmatriculare',
      inventoryEmpty: 'Inventarul CargoTrack este gol. Rulează „Actualizează acum”, apoi reîncarcă lista.',
      adminOnly: 'Numai administratorul poate modifica asocierea sau accepta o citire suspectă.',
      saved: 'Asocierea CargoTrack a fost salvată.',
    },
    history: {
      title: 'Istoric cicluri', empty: 'Nu există cicluri în istoric.', completed: 'Finalizat {{date}}',
      open: 'În desfășurare', intervention: 'Intervenția #{{id}}',
    },
    completion: {
      title: 'Finalizează intervenția', date: 'Data și ora finalizării', km: 'Kilometraj efectiv',
      proposed: 'Citire CAN propusă: {{value}} km din {{date}}',
      noProposal: 'Nu există o citire CAN validă în intervalul de 24 de ore.',
      help: 'Corectarea valorii aici nu modifică kilometrajul CAN curent.', submit: 'Finalizează',
    },
    service: {
      linkedTitle: 'Intervenție pentru planul de mentenanță',
      linkedText: 'Camionul și ciclul sunt precompletate pentru a păstra istoricul și următoarea scadență corecte.',
    },
    notices: {
      saved: 'Planul de mentenanță a fost salvat.', typeSaved: 'Tipul de mentenanță a fost salvat.',
      loadFailed: 'Datele de mentenanță nu au putut fi încărcate.',
      noCargoFeature: 'CargoTrack nu este activ pentru această firmă. Planurile calendaristice rămân disponibile.',
    },
  },
  en: {
    eyebrow: 'Fleet management', title: 'Truck maintenance', subtitle: 'Track maintenance by CAN mileage and date in one place.',
    actions: {
      refresh: 'Update now', refreshing: 'Updating…', newPlan: 'New plan', types: 'Work types', cargoTrack: 'CargoTrack setup',
      filters: 'Filters', clearFilters: 'Reset', edit: 'Edit plan', schedule: 'Schedule service', openService: 'Open intervention',
      history: 'History', save: 'Save', saving: 'Saving…', close: 'Close', acceptReading: 'Accept reading', retry: 'Try again',
      previous: 'Previous', next: 'Next', addType: 'New type', editType: 'Edit type', bind: 'Save association',
    },
    summary: { total: 'Active plans', urgent: 'Urgent on this page', stale: 'Stale CAN on this page', daily: 'Automatic update', dailyValue: 'Daily at 06:00', dailyHint: 'Company time' },
    filters: {
      truck: 'Truck', allTrucks: 'All trucks', importance: 'Importance', allImportance: 'All levels', status: 'Status',
      allStatuses: 'All statuses', scheduled: 'With scheduled service', stale: 'Stale mileage', withinDays: 'Due within (days)', withinKm: 'Due within (km)',
    },
    list: {
      title: 'Fleet maintenance', count: '{{count}} plans', emptyTitle: 'No plans match the selected filters',
      emptyText: 'Reset the filters or create the first maintenance plan.', truck: 'Truck', work: 'Work', due: 'Due',
      odometer: 'CAN mileage', importance: 'Importance', action: 'Actions', estimated: 'Estimate: {{date}}', noEstimate: 'Estimate unavailable',
      cycle: 'Cycle {{number}}', page: 'Page {{current}} of {{total}}', verificationIncomplete: 'Verification is incomplete because CAN data is missing',
    },
    statuses: { OK: 'OK', DUE_SOON: 'Approaching', DUE: 'Due', OVERDUE: 'Overdue', UNKNOWN: 'Insufficient data' },
    remaining: {
      km: '{{value}} km remaining', kmOverdue: '{{value}} km overdue', days: '{{value}} days remaining',
      daysOverdue: '{{value}} days overdue', today: 'Due today', noCriteria: 'Due date unavailable',
      dueKm: 'at {{value}} km', dueDate: 'on {{value}}',
    },
    odometer: {
      source: 'Source: CAN', value: '{{value}} km', recorded: 'Reading {{date}}', checked: 'Checked {{date}}', noValue: 'No CAN mileage',
      valid: 'Current', stale: 'Older than 24 h', unavailable: 'CargoTrack not associated', awaiting_sync: 'Waiting for sync',
      missing_can: 'CAN is missing', invalid_can: 'Invalid CAN value', invalid_timestamp: 'Invalid reading time',
      needs_review: 'Reading needs review', provider_unavailable: 'CargoTrack unavailable',
      acceptQuestion: 'Confirm only after comparing it with the truck dashboard.',
    },
    sync: {
      queued: 'The update is queued.', running: 'CargoTrack data is updating.', completed: 'Maintenance data was updated.',
      partial: 'The update completed with some errors.', failed: 'The update could not be completed.',
      progress: '{{processed}} processed · {{errors}} errors',
      throttled: 'Manual updates are limited. Try again in {{seconds}} seconds.',
      unavailable: 'Update limiting is temporarily unavailable. Existing data was kept.',
    },
    plan: {
      newTitle: 'New maintenance plan', editTitle: 'Edit maintenance plan', truck: 'Truck', type: 'Work type', title: 'Plan name',
      importance: 'Importance (0–5)', recurring: 'Recurring work', enabled: 'Active plan', intervalKm: 'Mileage interval',
      calendarUnit: 'Calendar interval', noCalendar: 'No calendar interval', days: 'Days', months: 'Months',
      calendarValue: 'Interval value', basis: 'Starting point', lastService: 'Last intervention', directDue: 'Direct due value',
      lastDate: 'Last intervention date', lastKm: 'Last intervention mileage', dueDate: 'Next due date', dueKm: 'Next due mileage',
      sourceIntervention: 'Completed Service intervention (optional)', sourceInterventionNone: 'Enter the last intervention manually',
      notifyKm: 'Mileage warnings', notifyKmHint: 'Comma-separated values, for example 2000, 500', notifyDays: 'Day warnings',
      notifyDaysHint: 'Comma-separated values, for example 30, 7', responsible: 'Owner', recipients: 'Notification recipients',
      noResponsible: 'No owner', recipientsUnavailable: 'Company users can be selected by an administrator.',
      extraAlerts: 'Additional warnings', costAlert: 'Warn when cost exceeds a threshold', costThreshold: 'Cost threshold',
      missingDocument: 'Completed without a document', usageAfterDue: 'Truck used after an importance-5 item became overdue',
      dateOnlyHint: 'A calendar-only plan works without valid CAN data.',
    },
    types: {
      title: 'Maintenance types', subtitle: 'Defaults are copied to the plan and can be adjusted per truck.', name: 'Name',
      category: 'Service category', enabled: 'Active type', empty: 'No types are defined.',
      preventive_maintenance: 'Preventive maintenance', repair: 'Repair', periodic_revision: 'Periodic inspection', accident: 'Accident',
    },
    cargo: {
      title: 'CargoTrack setup', subtitle: 'The association is manual and uses CAN mileage only.', truck: 'Truck', object: 'CargoTrack object',
      noObject: 'No association', suggested: 'Suggested from the registration number',
      inventoryEmpty: 'The CargoTrack inventory is empty. Run “Update now”, then reload the list.',
      adminOnly: 'Only an administrator can change the association or accept a suspicious reading.',
      saved: 'The CargoTrack association was saved.',
    },
    history: { title: 'Cycle history', empty: 'There are no cycles in history.', completed: 'Completed {{date}}', open: 'In progress', intervention: 'Intervention #{{id}}' },
    completion: {
      title: 'Complete intervention', date: 'Completion date and time', km: 'Actual mileage',
      proposed: 'Suggested CAN reading: {{value}} km from {{date}}', noProposal: 'No valid CAN reading exists within 24 hours.',
      help: 'Correcting this value does not change current CAN mileage.', submit: 'Complete',
    },
    service: {
      linkedTitle: 'Maintenance-plan intervention',
      linkedText: 'The truck and cycle are prefilled so history and the next due value remain correct.',
    },
    notices: {
      saved: 'The maintenance plan was saved.', typeSaved: 'The maintenance type was saved.',
      loadFailed: 'Maintenance data could not be loaded.',
      noCargoFeature: 'CargoTrack is not enabled for this company. Calendar plans remain available.',
    },
  },
};

export default maintenanceCatalog;
